import React from 'react';
import { Box, Typography } from '@mui/material';
import { portalProgressTrackSx } from '../../../styles/portalSurfaces';
import { getFunnelColorForValue } from '../Styles/widgetColors';

/** Minimum bar fill width (%) before the label moves inside the colored segment. */
const LABEL_INSIDE_MIN_PERCENT = 18;

export const formatFunnelPercent = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0%';
  if (Number.isInteger(n)) return `${n}%`;
  return `${parseFloat(n.toFixed(2))}%`;
};

const FunnelProgressBar = ({
  value,
  formatLabel = formatFunnelPercent,
  getBarColor = getFunnelColorForValue,
  height = 30,
  labelFontSize = 10,
}) => {
  const percentage = Math.min(100, Math.max(0, Number(value) || 0));
  const label = formatLabel(percentage);
  const showLabelInside = percentage >= LABEL_INSIDE_MIN_PERCENT;

  return (
    <Box
      sx={{
        height,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 1,
      }}
    >
      <Box sx={portalProgressTrackSx} />
      {percentage > 0 ? (
        <Box
          sx={{
            width: `${percentage}%`,
            height: '100%',
            backgroundColor: getBarColor(percentage),
            borderRadius: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            pr: 1,
            transition: 'width 0.5s ease-in-out',
          }}
        >
          {showLabelInside ? (
            <Typography
              sx={{
                color: 'common.white',
                fontSize: labelFontSize,
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                lineHeight: 1,
              }}
            >
              {label}
            </Typography>
          ) : null}
        </Box>
      ) : null}
      {!showLabelInside ? (
        <Typography
          sx={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            left: percentage === 0 ? 8 : `calc(${percentage}% + 6px)`,
            color: percentage === 0 ? 'text.secondary' : 'text.primary',
            fontSize: labelFontSize,
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            lineHeight: 1,
            pointerEvents: 'none',
          }}
        >
          {label}
        </Typography>
      ) : null}
    </Box>
  );
};

export default FunnelProgressBar;
